"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractFilteredApplicationsCommand = void 0;
const AbstractCommand_1 = require("../AbstractCommand");
class AbstractFilteredApplicationsCommand extends AbstractCommand_1.AbstractCommand {
    constructor() {
        super(...arguments);
        this.filter = {};
        this.withApplicationID = (appId) => {
            this.filter.pushApplicationID = appId;
            return this;
        };
        this.withName = (name) => {
            this.filter.name = name;
            return this;
        };
        this.withDeveloper = (developer) => {
            this.filter.developer = developer;
            return this;
        };
        this.withFilter = (filter) => {
            this.filter = {
                ...this.filter,
                ...filter,
            };
            return this;
        };
    }
}
exports.AbstractFilteredApplicationsCommand = AbstractFilteredApplicationsCommand;
//# sourceMappingURL=AbstractFilteredApplicationsCommand.js.map